// extracted by mini-css-extract-plugin
module.exports = {"modal-content":"NoticeOfPrivacy_modal-content_3__tY"};